module.exports = __webpack_public_path__ + "static/game_on-7c05a633d103a523de27a616dbb34765.ttf";